var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EAECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3125 18.915C27.2197 18.7863 27.0976 18.6816 26.9563 18.6094C26.8151 18.5373 26.6586 18.4998 26.5 18.5H25.5V17.5C25.5 17.2348 25.3946 16.9804 25.2071 16.7929C25.0196 16.6054 24.7652 16.5 24.5 16.5H20.1669L18.4338 15.2C18.2604 15.0707 18.05 15.0006 17.8337 15H14.5C14.2348 15 13.9804 15.1054 13.7929 15.2929C13.6054 15.4804 13.5 15.7348 13.5 16V25C13.5 25.1326 13.5527 25.2598 13.6464 25.3536C13.7402 25.4473 13.8674 25.5 14 25.5H25.1938C25.2987 25.5 25.401 25.467 25.4861 25.4056C25.5713 25.3443 25.6349 25.2577 25.6681 25.1581L27.4487 19.8162C27.4988 19.6659 27.5126 19.5059 27.4889 19.3493C27.4652 19.1926 27.4048 19.0438 27.3125 18.915ZM17.8337 16L19.5669 17.3C19.7402 17.4293 19.9506 17.4995 20.1669 17.5H24.5V18.5H16.3606C16.1507 18.5 15.9462 18.566 15.7759 18.6887C15.6056 18.8114 15.4783 18.9846 15.4119 19.1838L14.5 21.9187V16H17.8337Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folderIcon.982493834e64182c3d1f03531972a475.svg";
export { ForwardRef as ReactComponent };